import { render, staticRenderFns } from "./CrewsAdd.vue?vue&type=template&id=452b3862"
import script from "./CrewsAdd.vue?vue&type=script&lang=js"
export * from "./CrewsAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports